import { omitBy, isNil, isEmpty } from "lodash";

const model = (data) => {
  // filter out any element with ""
  const dataOnlyWhitelist = data.whitelist.filter((w) => w !== "");

  // if it is empty, make it null
  const onlyWhitelist = isEmpty(dataOnlyWhitelist) ? [] : dataOnlyWhitelist;

  const basePayload = {
    daysToExpire: data.daysToExpire,
    ipAddresses: onlyWhitelist,
  };

  let appendedPayload = {};

  // if there is an isNew, there is no id
  if (data.isNew) {
    appendedPayload = {
      ...basePayload,
      type: data.type,
      companyOrgID: data.companyOrgID,
      rackID: data.rackID,
      // service point id can be "" to represent all locations
      servicePointID: data.servicePointID,
    };
  } else {
    appendedPayload = { ...basePayload, _id: data._id };
  }

  return omitBy(appendedPayload, (val) => isNil(val) || val === "");
};

export default model;
